import { ComponentType } from "react";

import ArrowTopRightOnSquareIcon from "@heroicons/react/20/solid/ArrowTopRightOnSquareIcon";

import styles from "../AdminPanel.module.scss";

export type AdminToolComponentProps = {
  description: string;
  isOpen: boolean;
  onDismiss: () => void;
  title: string;
};

type AdminToolProps = {
  Component: ComponentType<AdminToolComponentProps>;
  Icon: ComponentType<any>;
  description: string;
  isOpen: boolean;
  onClick: () => void;
  onDismiss: () => void;
  title: string;
};

export default function AdminTool({
  Component,
  Icon,
  description,
  isOpen,
  onClick,
  onDismiss,
  title,
}: AdminToolProps) {
  return (
    <>
      <button className={styles.tool} onClick={onClick}>
        <div className={styles.toolTop}>
          <Icon className={styles.toolIcon} />
          <p className={styles.toolTitle}>{title}</p>
          <ArrowTopRightOnSquareIcon className={styles.toolArrowIcon} />
        </div>
        <p className={styles.toolDescription}>{description}</p>
      </button>

      {isOpen && (
        <Component
          description={description}
          isOpen
          onDismiss={onDismiss}
          title={title}
        />
      )}
    </>
  );
}
